export const CONTENT_MAX_WIDTH = "max-w-[clamp(280px,85vw,480px)]";
export const PANEL_MAX_WIDTH = "max-w-[clamp(280px,90vw,720px)]";

export const FULLSCREEN_QUEUE_BG_CLASS = "fullscreen-queue-bg";
